import React, { useEffect, useState } from "react";
import {
  Box,
  FormElementWrapper,
  LabelStyled,
  SpanStyled,
  ThemeLoader,
} from "../../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import { FormRadioWrapper } from "./styled";
import { Field, useFormikContext } from "formik";
import CabinetsApi from "../../../../../services/api/cabinetsApi";

const Statuses = () => {
  const { t, i18n: { language } } = useTranslation();
  const { setFieldValue, values } = useFormikContext();

  const [isLoading, setIsLoading] = useState(false);
  const [statusTypeOptions, setStatusTypeOptions] = useState([]);

  const getArchiveStatusTypes = async () => {
    try {
      const { data, code } = await CabinetsApi.getArchiveStatusTypes();
      if (code === 200 && data) {
        setStatusTypeOptions(
          data?.map((option) => ({
            ...option,
            name: language === "en" ? option?.name_en : option?.name_ar,
          }))
        );
      }
    } catch (error) {}
  };

  useEffect(() => {
    getArchiveStatusTypes();
  }, []);

  if(isLoading) {
    return (
        <Box className="d-flex align-items-center justify-content-center w-100">
            <ThemeLoader />
        </Box>
    )
  };

  return (
    <FormElementWrapper>
      <Box className="formEleContainer">
        <LabelStyled className="labelForm">{t("status")}*</LabelStyled>
        <Box>
          <Box className="radiosContainer">
            {statusTypeOptions?.map((x, i) => {
                return (
                    <FormRadioWrapper className="archiveRadios">
                        <Field
                            type="radio"
                            name="archive_status_id"
                            className="radio-input"
                            value={x.id}
                            checked={values.archive_status_id === x.id}
                            onChange={(e) => {
                                setFieldValue("archive_status_id", Number(e.target.value));
                            }}
                        />
                        <Box>
                            <SpanStyled
                            as="label"
                            size="16px"
                            color="var(--text)"
                            checked={values.archive_status_id === x.id}
                            className="radio-label"
                            >
                                {t(x.name)}
                            </SpanStyled>
                        </Box>
                    </FormRadioWrapper>
                )
            })}
          </Box>
        </Box>
      </Box>
    </FormElementWrapper>
  );
};

export default Statuses;
